import type { PrintCoordinatorRuntime } from "./PrintCoordinator";

/** Keep the lock until in-flight paper finishes; followers must not print it again. */
export function startPrintCoordinatorOwner(
  runtime: PrintCoordinatorRuntime,
  deviceId: string,
  locks: Pick<LockManager, "request"> | undefined,
  onFailure: () => void,
): () => void {
  const controller = new AbortController();
  let stopped = false;
  let release: (() => void) | undefined;
  const own = async () => {
    if (stopped) return;
    const released = new Promise<void>((resolve) => { release = resolve; });
    runtime.start();
    await released;
    await runtime.stop();
  };
  if (locks) {
    void locks.request(`restaurant-print:${deviceId}`, { signal: controller.signal }, own).catch(() => {
      if (!stopped) onFailure();
    });
  } else {
    // Server leases remain the duplicate-claim guard on browsers without Web Locks.
    void own();
  }
  return () => {
    stopped = true;
    controller.abort();
    void runtime.stop();
    release?.();
  };
}
